import { Grid, LinearProgress, Typography } from '@mui/material';

export const TotalCuts = ({
    totalCuts,
    numCutType,
    color,
    minWidth = '200px',
}: {
    totalCuts: number;
    numCutType: number;
    color: 'success' | 'error';
    minWidth?: string;
}) => {
    return (
        <Grid item display={'flex'} flexDirection={'row'} flex={1} width={'100%'} alignItems={'center'} gap={2}>
            <LinearProgress
                variant='determinate'
                value={totalCuts === 0 ? 0 : (numCutType / totalCuts) * 100}
                color={color}
                sx={{ backgroundColor: '#e0e0e0', width: '100%', minWidth }}
            />
            <Typography variant='body2' color={'grey'}>
                {numCutType}
            </Typography>
        </Grid>
    );
};
